import type React from 'react';

type CombinableRef<T> = React.Ref<T> | ((node: T | null) => void) | undefined;

/**
 * Builds one callback ref that writes the node into every given ref.
 */
const useCombinedRef = () => {
  const combinedRef = <T>(refs: CombinableRef<T>[]) => (node: T | null): void => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref != null) {
        (ref as React.MutableRefObject<T | null>).current = node;
      }
    });
  };

  return { combinedRef };
};

export default useCombinedRef;
